import './index.css';
import { useTranslation } from 'react-i18next';
import { UserDto } from 'api-types';
import { useNavigate } from 'react-router-dom';
import { ReactNode, useCallback } from 'react';
import useAmplifyAuth from 'hooks/useAmplifyAuth';

interface IProps {
    user: UserDto;
}

export function Welcome({ user }: Readonly<IProps>): ReactNode {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { handleSignout } = useAmplifyAuth();

    const handleLogout = useCallback(() => {
        navigate('/login');
        void handleSignout();
    }, [handleSignout, navigate]);

    return (
        <div className='user-info box'>
            {t('hello')} {user.displayName}
            <div className='user-info-options'>
                {user.employeeCode}
                <div className='logout' onClick={handleLogout}>
                    {t('logout')}
                </div>
            </div>
        </div>
    );
}
